<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/careers",
		    "name": "Careers"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>Careers</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<!-- Start Introduction -->
<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-career.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
                    <h1 id="bnr-heading">{{heading}}</h1>
                    <h2 id="bnr-subheading">{{subheading}}</h2>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Introduction -->

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile-career.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                    <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
            </div>
        </div>
    </div>
</div>

<div class="careergallery">
    <div class="container section-pb-60">
        <div class="section-title text-center">
            <h4>Life at Protectt.<span class="redcolor">ai</span></h4>
        </div>
        <div class="row">
            <div class="col-12">
                <swiper [loop]="true" [autoHeight]="true" [allowTouchMove]="true"
                    [autoplay]="{ delay: 3000, disableOnInteraction: false }"
                    [slidesPerView]="innerWidth > 767 ? 3 : 1 " [spaceBetween]="0">
                    <ng-template data-swiper-autoplay="6000" class="swiper-slide" swiperSlide
                        *ngFor="let slide of slides1">
                        <a class="card border-0">
                            <img src="{{slide.img}}" alt="slide" id="slide" class="card-img-top img-fluid w-100">
                        </a>
                    </ng-template>
                </swiper>
            </div>
        </div>
    </div>
</div>

<div class="container section-pb-60 employeespeaksection">
    <div class="section-title text-center">
        <h4>Employee Speak</h4>
    </div>
    <div class="row">
        <!-- <div class="col-md-2"></div>
        <div class="col-md-8 text-center">
            <a href="javascript://" class="" data-toggle="modal" data-target="#playEmplyoeeVideo"
                    (click)="onClickPdfView('video/employee_speak.mp4')">
                    <img src="../../../assets/images/careers/employee_speak.webp" alt="employee_speak" width="100%" height="auto">
                </a>
        </div>
        <div class="col-md-2"></div> -->
        <div class="col-md-8 mt-3">
            <div class="video video-1">
                <a href="javascript://" class="mainvideoimage" data-toggle="modal" data-target="#playEmplyoeeVideo"
                    (click)="onClickPdfView(careerVideos[activeVideoIndex].video)">
                    <img [src]="careerVideos[activeVideoIndex].poster" alt="careerVideos" width="100%" height="auto" [title]="careerVideos[activeVideoIndex].title">
                </a>
            </div>
        </div>
        <div class="col-md-4 text-right mt-3">
            <div class="grid-row reverse video-gallery">
                <div class="card px-4 py-4 videolist">
                    <div class="d-flex align-items-center video-list" *ngFor="let video of careerVideos;let i = index;">
                        <input type="radio" [value]="i" name="video-list{{i}}" id="video-{{i}}"
                            [checked]="activeVideoIndex == i" />
                        <label for="video-{{i}}" (click)="activeVideoIndex = i;" class="col-md-5 p-0">
                            <img [src]="video.poster" alt="poster" width="100%" class="listvideoimg" [title]="video.title">
                        </label>
                        <p class="col-md-7 height-50-hidden m-0" title="{{video.title}}" (click)="activeVideoIndex = i;">{{video.title}}</p>
                    </div>
                </div>
                </div>
        </div>
    </div>
</div>

<div class="section-agency-benefit section-pt careercard">
    <div class="container">
        <div class="row">

            <div class="col-md-4 col-lg-4">
                <div class="card">
                    <div class="card-body text-center">
                        <ul>
                            <li><img src="assets/images/careers/lively-work-culture.png" alt="Lively Work Culture">
                            </li>
                        </ul>
                        <h6 class="card-title font-weight-bold">Lively Work Culture</h6>
                        <p class="card-text center-text">Being a startup we have a wonderful ambience of
                            workstation
                            with new age work culture. Our
                            healthy and lively workplace will give all the employees with flexibility in
                            organizing
                            where and how they contribute and participate as
                            team and gets work done</p>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-lg-4">
                <div class="card">
                    <div class="card-body text-center">
                        <ul>
                            <li><img src="assets/images/careers/constructive-information.png"
                                    alt="Constructive Information"></li>
                        </ul>
                        <h6 class="card-title font-weight-bold">Constructive Information</h6>
                        <p class="card-text center-text">Protectt.ai offers unique opportunities to address the
                            business
                            demands that meet your
                            passion to contribute on the best in class products. We give free hands to innovate
                            through effective research and development to Protectt
                            the digital world.</p>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-lg-4">
                <div class="card">
                    <div class="card-body text-center">
                        <ul>
                            <li><img src="assets/images/careers/persistance-up-skilling.png"
                                    alt="Persistent Up-Skilling"></li>
                        </ul>
                        <h6 class="card-title font-weight-bold">Persistent Up-Skilling</h6>
                        <p class="card-text center-text">Ensuring our team to have the knowledge and skills to
                            deliver
                            excellent service is essential.
                            Through a formal coaching and self initiatives, Protectt.ai provides endless
                            learning
                            opportunities to improve your capability as fully
                            equipped engineer.</p>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-lg-4">
                <div class="card">
                    <div class="card-body text-center">
                        <ul>
                            <li><img src="assets/images/careers/able-leadership.png" alt="Able Leadership"></li>
                        </ul>
                        <h6 class="card-title font-weight-bold">Able Leadership</h6>
                        <p class="card-text center-text">We believe, Process yields the result and our leaders
                            are
                            process driven. Aiming towards
                            delivering cutting edge innovative technology solution. And we would like to see
                            leadership quality from everyone in our team irrespective
                            of age, experience, gender and designation.</p>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-lg-4">
                <div class="card">
                    <div class="card-body text-center">
                        <ul>
                            <li><img src="assets/images/careers/organisational-responsibility.png"
                                    alt="Organizational Responsibility"></li>
                        </ul>
                        <h6 class="card-title font-weight-bold">Organizational Responsibility</h6>
                        <p class="card-text center-text">How we conduct business is the fuel to our success. As
                            an
                            organization we recognize both the
                            opportunity & responsibility in identifying pressing global issues and converting
                            them into
                            optimal solution. We value our customer relationship
                            and help them stay ahead of their competitors.</p>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-lg-4">
                <div class="card">
                    <div class="card-body text-center">
                        <ul>
                            <li><img src="assets/images/careers/carrer-growth.png" alt="Career Growth"></li>
                        </ul>
                        <h6 class="card-title font-weight-bold">Career Growth</h6>
                        <p class="card-text center-text">We help you to push your limits and allow you take a
                            giant leap
                            in your career with
                            unique opportunities. We encourage you to track what you have done and what you can
                            do
                            beyond your comfort zone and helping you to discover,
                            apply and develop your strengths and talents. We offer dynamic career opportunities
                            that
                            allow you to realize new experiences without changing employers.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Start Service Style-->
<div class="section-service">

    <div class="container">
        <div class="section-title text-center">
            <h4>Job Openings</h4>
        </div>
        <div class="row" style="min-height: 50vh;">
            <div class="col-md-12">
                <div class="row mx-1">
                    <!-- Nav tabs -->
                    <!-- <ul role="tablist" class="nav flex-row service-details-menu dashboard-list col-6 leftside">
                        <div class="row">
                            <div class="dropdown ml-2">
                                <li><a class="dropbtn" style="font-weight: 500;" id="selector-job">Department ▼</a></li>
                                <div class="dropdown-content careerdropdown">
                                    <li><a (click)="storeJob('all')">All</a></li>
                                    <li><a (click)="storeJob('product')">Product Engineering</a></li>
                                    <li><a (click)="storeJob('marketing')">Marketing</a></li>
                                    <li><a (click)="storeJob('sales')">Sales</a></li>
                                    <li><a (click)="storeJob('hr')">HR & Accounts</a></li>
                                </div>
                            </div>

                            <div class="dropdown ml-2">
                                <li><a class="dropbtn selectedvalue" style="font-weight: 500;"
                                        id="selector-location">Location ▼</a></li>
                                <div class="dropdown-content">
                                    <li><a (click)="storeLocation('all')">All</a></li>
                                    <li><a (click)="storeLocation('mumbai')">Mumbai</a></li>
                                    <li><a (click)="storeLocation('chennai')">Chennai</a></li>
                                    <li><a (click)="storeLocation('gurgaon')">Gurgaon</a></li>
                                </div>
                            </div>
                            <div class="ml-2">
                                <button class="btn btn-lg btn-verticallycenter" (click)="filter()"><i class="fa fa-search" aria-hidden="true"></i></button>
                            </div>
                        </div>
                    </ul> -->
                    <div class="col-xs-12 col-sm-12 col-md-8 leftside text-center">
                        <div class="row">
                            <div class="col-md-2 col-lg-2 d-none d-md-block"></div>
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 mt-2 mb-2">
                                <div class="dropdown">
                                    <button class="btn dropdown-toggle" type="button" id="selector-job"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Department
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" (click)="storeJob('all')">ALL</a>
                                        <a class="dropdown-item" (click)="storeJob('product engineering')">Product
                                            Engineering</a>
                                        <a class="dropdown-item" (click)="storeJob('marketing')">Marketing</a>
                                        <a class="dropdown-item" (click)="storeJob('sales')">Sales</a>
                                        <!-- <a class="dropdown-item" (click)="storeJob('product engineering')">Java Developer</a>
                                        <a class="dropdown-item" (click)="storeJob('product engineering')">Android Developer</a>
                                        <a class="dropdown-item" (click)="storeJob('product engineering')">iOS Developer</a> -->
                                        <a class="dropdown-item" (click)="storeJob('hr & accounts')">HR & Accounts</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 mt-2 mb-2">
                                <div class="dropdown">
                                    <button class="btn dropdown-toggle" type="button" id="selector-location"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Location
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" (click)="storeLocation('all')">All</a>
                                        <a class="dropdown-item" (click)="storeLocation('mumbai')">Mumbai</a>
                                        <a class="dropdown-item" (click)="storeLocation('chennai')">Chennai</a>
                                        <a class="dropdown-item" (click)="storeLocation('gurgaon')">Gurgaon</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2 col-lg-2 d-none d-md-block"></div>
                            <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 mt-2 mb-2">
                                <button class="btn" (click)="filter()"><i class="fa fa-search"
                                        aria-hidden="true"></i></button>
                            </div> -->
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-4 text-center">
                        <h6 style="color: #da2b27;" class="verticalcenter">
                            Email your CV/Resume at: <a href="mailto:hr@protectt.ai"
                                style="font-weight: 600; color: #163e6f;">
                                hr@protectt.ai</a></h6>
                    </div>
                </div>

                <div class="row mx-1">
                    <div class="acc-kontainer">
                        <div class="row mb-3">
                            <div
                                class="col-12 filterDiv show1 product engineering product engineering marketing product engineering mumbai product engineering mt-4">
                                <h3>Mumbai</h3>
                            </div>

                            <div class="col-md-6 col-xs-12 filterDiv show1 product engineering mumbai mt-3">
                                <input type="checkbox" name="acc" id="acc9" class="career-input"
                                    onclick="getevent(this)">
                                <label for="acc9">Android Developer<br /><br /><b>Location :
                                    </b><span>Mumbai</span><br /><b>Experience : </b><span>4+
                                        Yrs</span><br /><b>Qualification : </b><span>B. E/ B. Tech/ M.E/ MTech/
                                        MCA</span>
                                    <br /><b>Description : </b><span>We are looking for highly motivated and quick
                                        learning individual with great leadership skills and the capacity to
                                        efficiently utilize and contribute to your team s technical skills.</span>
                                    <br /><b class="dispnone careerreadmore">Read More →</b>
                                </label>
                                <div class="acc-body">
                                    <p class="mb-0"><b>Role: </b>Android Developer</p>
                                    <!-- <p class="mb-0 mt-0"><b>Job Location:</b> Mumbai
                                    <p class="mb-0 mt-0"><b>Experience:</b> 2 to 7 Yrs -->
                                    <!-- <p class="mb-0 mt-0"><b>Qualification:</b> B.E/ B. Tech/ M.E/ M.Tech/ MCA -->
                                    <p class="mb-0"><b>Job Description: </b>We are looking for highly motivated and
                                        quick learning individual with great leadership skills and the capacity to
                                        efficiently utilize and contribute to your team s technical skills. The ability
                                        to understand requirements, provide
                                        solutions, and collaborate efficiently and amicably with your team and with
                                        clients. The ability to work with the design
                                        team to implement mobile strategies. The focus to adapt and respond to
                                        challenges as they come up. Excellent time
                                        management skills and dedication to achieving high quality work.</p>
                                    <p class="mb-0 mt-0"><b>Responsibilities:</b></p>
                                    <ol>
                                        <li>Hands-on Application development knowledge on Kotlin language with MVVM /
                                            MVP architecture is must.</li>
                                        <li>The senior android engineer is expected to have published 5+ applications on
                                            play store.</li>
                                        <li>High level knowledge of Java I/O, Collections, Algorithms and other
                                            well-known application frameworks</li>
                                        <li>Experience with JSON to interfacing Android applications to server-side APIs
                                        </li>
                                        <li>Experience with source code management techniques using Git.</li>
                                        <li>Ability to develop rich GUIs for Android with latest material design and
                                            libraries.</li>
                                        <li>Constant awareness of the latest technological developments and a high level
                                            of expertise</li>
                                        <li>Having experience in Consumer App experience (B2C), designing and developing
                                            B2C Apps with interactive
                                            UI/UX, consumer engagement with Notifications and app analytics.</li>
                                    </ol>
                                    <p class="mb-0 mt-0"><b>Preferred:</b></p>
                                    <ol>
                                        <li>Published apps available for immediate download from Play Store</li>
                                        <li>Ability to develop APIs</li>
                                        <li>Experience developing user-facing applications</li>
                                        <li>Flexible, adaptable, and able to multi-task</li>
                                    </ol>
                                    
                                        <!-- <a href="javascript://" class="btn" data-toggle="modal"
                                        data-target="#applybtn">Apply Now</a> -->
                                   
                                </div>
                            </div>

                            <div class="col-md-6 col-xs-12 filterDiv show1 product engineering mumbai mt-3">
                                <input type="checkbox" name="acc" id="acc7" class="career-input"
                                    onclick="getevent(this)">
                                <label for="acc7">iOS Developer <br /><br /><b>Location :
                                    </b><span>Mumbai</span><br /><b>Experience : </b><span>4+
                                        Yrs</span><br /><b>Qualification : </b><span>B. E/ B. Tech/ M.E/ MTech/
                                        MCA</span>
                                    <br /><b>Description : </b><span>Should have hands-on experience in
                                        iOS applications and SDK development.Having experience with Swift programming
                                        language is a must.</span>
                                    <br /><b class="dispnone careerreadmore">Read More →</b>
                                </label>
                                <div class="acc-body">
                                    <p class="mb-0"><b>Role: </b>iOS Developer </p>
                                    <!-- <p class="mb-0 mt-0"><b>Job Location:</b> Mumbai
                                    <p class="mb-0 mt-0"><b>Experience:</b> 2 to 7 Yrs -->
                                    <!-- <p class="mb-0 mt-0"><b>Qualification:</b> B.E/ B. Tech/ M.E/ M.Tech/ MCA -->
                                    <p class="mb-0 mt-0"><b>Responsibilities:</b></p>
                                    <ol>
                                        <li>Should have hands-on experience in iOS applications and SDK development.
                                        </li>
                                        <li>Having experience with Swift programming language is a must.</li>
                                        <li>Prior experience in the basics of secure code development, like Jail Broken
                                            detection
                                            and advanced cryptographic algorithms, would be an added advantage.
                                        </li>
                                        <li>Working knowledge of Custom views, Animations, Services, and Database</li>
                                        <li>Solid understanding of the entire mobile development life cycle</li>
                                        <li>Should have published at least one original iOS app to the App store and
                                            supported it for one year.</li>
                                        <li>Expected to know Git repo management and release automation.</li>
                                        <li>Prior experience in the banking domain or Fraud and Risk management
                                            solutions
                                            would be an added advantage.</li>
                                        <li>Being a senior iOS engineer should be able to map the business requirement
                                            into
                                            an effective solution.</li>
                                        <li>Possess sufficient knowledge and skills to deal with issues effectively and
                                            challenges
                                            and troubleshoot any problems with a high sense of ownership.</li>
                                        <li>Should be able to devise solutions from a technology perspective and
                                            coordinate with
                                            the team in achieving a single common goal.</li>
                                        <li>
                                            Expected to guide the juniors and help them understand the conversion of
                                            business requirements into best-in-class solutions.
                                        </li>
                                    </ol>
                                    
                                    <!-- <a href="javascript://" class="btn" data-toggle="modal"
                                        data-target="#applybtn">Apply Now</a> -->
                                   
                                </div>
                            </div>

                            <div class="col-md-6 col-xs-12 filterDiv show1 product engineering mumbai mt-3">
                                <input type="checkbox" name="acc" id="acc6" class="career-input"
                                    onclick="getevent(this)">
                                <label for="acc6">Mobile Application Security Researcher/Tester<br /><br /><b>Location :
                                    </b><span>Mumbai</span><br /><b>Experience : </b><span>2 to 7
                                        Yrs</span><br /><b>Qualification : </b><span>B. E/ B. Tech/ M.E/ MTech/
                                        MCA</span><br /><b>Description : </b><span>Researching, evaluating, and helping
                                        developers to improve defensive tactics,
                                        techniques to secure the mobile application from threats and
                                        vulnerabilities.</span>
                                    <br /><b class="dispnone careerreadmore">Read More →</b>
                                </label>
                                <div class="acc-body">
                                    <p class="mb-0"><b>Role: </b>Mobile Application Security Researcher/Tester</p>
                                    <!-- <p class="mb-0 mt-0"><b>Job Location:</b> Mumbai
                                    <p class="mb-0 mt-0"><b>Experience:</b> 2 to 7 Yrs -->
                                    <!-- <p class="mb-0 mt-0"><b>Qualification:</b> B.E/ B. Tech/ M.E/ M.Tech/ MCA -->
                                    <p class="mb-0 mt-0"><b>Responsibilities:</b></p>
                                    <ol>
                                        <li>Researching, evaluating, and helping developers to improve defensive
                                            tactics, techniques to
                                            secure the mobile application from threats and vulnerabilities.</li>
                                        <li>Strong understanding of vulnerability assessment and triage</li>
                                        <li>2+ years of experience in Mobile Application Security and related security
                                            scanning and manual
                                            tools such as MobSF, Yaazini, APKTool, Frida, JADX, LSPosed / Xposed,
                                            Ghidra, Hopper, IDA Pro.
                                        </li>
                                        <li>2+years of experience in consultancy and support to application teams,
                                            including security
                                            scanning tool onboarding, vulnerability review and triage, false positive
                                            and rating challenges,
                                            scanning eligibility, and exceptions.</li>
                                        <li>Professional cybersecurity certificates on mobile application security are
                                            preferred.</li>
                                    </ol>
                                    <p class="mt-0 mb-0 "><b>Preferred:</b></p>
                                    <ol>
                                        <li>Mobile Application Security Assessment (Both Android and iOS)</li>
                                        <li>Security Scanning Tools - Onboarding, Vulnerability review, False positive
                                        </li>
                                        <!-- <li>A CEH certification will be an advantage.</li> -->
                                    </ol>
                                    
                                    <!-- <a href="javascript://" class="btn" data-toggle="modal"
                                        data-target="#applybtn">Apply Now</a> -->
                                     
                                </div>
                            </div>

                            <div class="col-md-6 col-xs-12 filterDiv show1 marketing mumbai mt-3">
                                <input type="checkbox" name="acc" id="acc1" class="career-input"
                                    onclick="getevent(this)">
                                <label for="acc1">PR and Corporate Communication
                                    Specialist<br /><br /><b>Location : </b><span>Mumbai</span><br /><b>Experience :
                                    </b><span>5 to 9 Yrs</span><br /><b>Qualificaion : </b><span>B.Tech/ BBA /
                                        MBA</span><br /><b>Description : </b><span>A PR Communications
                                        professional for Protectt.ai Labs Pvt Ltd will be responsible for
                                        contributing to building a strong brand public image in the editorial
                                        space.</span>
                                    <br /><b class="dispnone careerreadmore">Read More →</b>
                                </label>
                                <div class="acc-body">
                                    <p class="mb-0"><b>Role: </b>PR and Corporate Communication Specialist</p>

                                    <!-- <p class="mb-0 mt-0"><b>Job Location:</b> Mumbai
                                    <p class="mb-0 mt-0"><b>Experience:</b> 5 to 9 Yrs -->
                                    <!-- <p class="mb-0 mt-0"><b>Qualification:</b> B.Tech/ BBA / MBA</p> -->
                                    <p class="mb-0 mt-0"><b>Roles & Responsibilities:</b></p>
                                    <ol>
                                        <li>Should be experience in PR agency handling and related coordination</li>
                                        <li>Should be expert in PR strategy formulation</li>
                                        <li>Proofread, re-structure and edit articles by content writers on a daily
                                            basis to check spelling,
                                            language usage, grammar, and consistency/relevance of content.</li>
                                        <li>Manage the editorial calendar and ensure timely submission.</li>
                                        <li>Should be able to perform research on the given articles.</li>
                                        <li>Perform factual checks on the content.</li>
                                        <li>Provide a daily report to the quality manager i.e., the reporting manager
                                        </li>
                                        <li>Offer feedback to the writers after editing their content.</li>
                                        <li>Report/Communicate specific editing problems to the project teams.</li>
                                        <li>Coordinate with reporting manager on client revision requests and get them
                                            done within the
                                            deadline.</li>
                                        <li>Work on understanding specific project guidelines of the work for the day.
                                        </li>
                                        <li>Passion for writing and editing content.</li>
                                        <li>Understand the target audience and guide the writers to create content that
                                            is appropriate for
                                            them</li>
                                        <li>Work with the design team to ensure that the design meets the brief and is
                                            serving the purpose
                                            of the project</li>
                                        <li>Create clear, concise content and UI text to improve the customer experience
                                        </li>
                                    </ol>
                                    <p class="mt-0 mb-0 "><b>Preferred:</b></p>
                                    <ol>
                                        <li>Bachelor or postgraduate in Journalism or related field.</li>
                                        <li>Excellent spoken and written English proficiency</li>
                                        <li>Preferred 5+ years of experience in SaaS/ IT/cyber security company.</li>
                                        <li>Strong interpersonal skills, team building and collaboration</li>
                                        <li>Clarity in thought process and a problem-solving attitude</li>
                                        <li>Comprehension skills</li>
                                        <li>Basic SEO knowledge is added advantage</li>
                                        <li>Time management skills</li>
                                        <li>Team player & have an eye for detail</li>
                                    </ol>
                                    
                                    <!-- <a href="javascript://" class="btn" data-toggle="modal"
                                        data-target="#applybtn">Apply Now</a> -->
                                   
                                </div>
                            </div>
                            <div class="col-md-6 col-xs-12 filterDiv show1 marketing mumbai mt-3">
                                <input type="checkbox" name="acc" id="acc2" class="career-input"
                                    onclick="getevent(this)">
                                <label for="acc2">Technical Content Writer<br /><br /><b>Location :
                                    </b><span>Mumbai</span><br /><b>Experience : </b><span>5+
                                        Yrs.</span><br /><b>Qualification :
                                    </b><span>Graduate</span><br /><b>Description : </b><span>We are looking for a
                                        Technical
                                        Writer to create customer-friendly sales enablement
                                        material, including but not limited to white papers, blogs, product brochures,
                                        case studies,
                                        articles, etc.</span>
                                    <br /><b class="dispnone careerreadmore">Read More →</b>
                                </label>
                                <div class="acc-body">
                                    <p class="mb-0"><b>Role:</b> Technical Content Writer</p>
                                    <p class="mb-0 mt-0"><b>Responsibilities:</b></p>
                                    <ol>
                                        <li>5 + Years of experience, must have experience writing IT, Deep tech, Cyber
                                            Security related content.</li>
                                        <li>Strong grasp of English language, usage, structure, styles, and writing
                                            principles to develop high-quality, error-free, and engaging content</li>
                                        <li>Creating blog posts, articles, presentations, white papers, case studies,
                                            and other types of content on the latest cybersecurity trends, techniques,
                                            threats, and other relevant topics</li>
                                        <li>Performing competition bench exercises for marketing content collateral
                                            creation</li>
                                        <li>Writing white papers, blogs, product brochures, and case studies</li>
                                        <li>Creative Writing</li>
                                        <li>Web page writing</li>
                                        <li>Competition tracking for similar documents</li>
                                        <li>Excellent attention to details</li>
                                        <li>Basic understanding of design theory</li>
                                        <li>Great research, organizational, and learning skills</li>
                                        <li>Ability to understand complex writing requirements and deliver quality
                                            content</li>
                                    </ol>
                                    
                                    <!-- <a href="javascript://" class="btn" data-toggle="modal"
                                        data-target="#applybtn">Apply Now</a> -->
                                   
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div
                                class="col-12 filterDiv show1 sales product engineering  product engineering product engineering product engineering chennai mt-4">
                                <h3>Chennai</h3>
                            </div>

                            <div class="col-md-6 col-xs-12 filterDiv show1 product engineering chennai mt-3">
                                <input type="checkbox" name="acc" id="acc12" class="career-input"
                                    onclick="getevent(this)">
                                <label for="acc12">Java Developer<br /><br /><b>Location :
                                    </b><span>Chennai</span><br /><b>Experience : </b><span>4+
                                        Yrs</span><br /><b>Qualification : </b><span>B. E/ B. Tech/ M.E/ MTech/
                                        MCA</span><br /><b>Description : </b><span>Development of new functionalities in
                                        the existing Protectt.ai platform on AWS Cloud. Work with the Engineering Team
                                        to analyze customization requests and convert them into product features.</span>
                                    <br /><b class="dispnone careerreadmore">Read More →</b>
                                </label>
                                <div class="acc-body">
                                    <p class="mb-0"><b>Role: </b>Java Developer</p>
                                    <!-- <p class="mb-0 mt-0"><b>Job Location:</b> Mumbai
                                    <p class="mb-0 mt-0"><b>Experience:</b> 2 to 7 Yrs -->
                                    <!-- <p class="mb-0 mt-0"><b>Qualification:</b> B.E/ B. Tech/ M.E/ M.Tech/ MCA -->
                                    <p class="mb-0"><b>Job Description: </b>Development of new functionalities in the
                                        existing Protectt.ai platform on AWS Cloud. Work with the Engineering Team to
                                        analyze customization requests and convert them into product features.</p>
                                    <p class="mb-0 mt-0"><b>Responsibilities:</b></p>
                                    <ol>
                                        <li>Development of new functionalities in the existing Protectt.ai platform on
                                            AWS Cloud.</li>
                                        <li>Work with the Engineering Team to analyze customization requests and convert
                                            them into product features.</li>
                                        <li>Understanding and hands-on experience in Spring Boot Micro Services.</li>
                                        <li>Knowledge of Data Base Basics is a must. Preferably in PostgreSQL.</li>
                                        <li>Implement best coding practices and use of Junit.</li>
                                        <li>Familiar with Deployment tools like WinSCP and Putty is important.</li>
                                    </ol>
                                    
                                    <!-- <a href="javascript://" class="btn" data-toggle="modal"
                                        data-target="#applybtn">Apply Now</a> -->
                                   
                                </div>
                            </div>

                            <div class="col-md-6 col-xs-12 filterDiv show1 product engineering chennai mt-3">
                                <input type="checkbox" name="acc" id="acc10" class="career-input"
                                    onclick="getevent(this)">
                                <label for="acc10">Android Developer<br /><b>Experience : </b><span>4+
                                        Yrs</span><br /><b>Location :
                                    </b><span>Chennai</span><br /><b>Qualification : </b><span>B. E/ B. Tech/ M.E/
                                        MTech/ MCA</span>
                                    <br /><b>Description : </b><span>We are looking for highly motivated and quick
                                        learning individual with great leadership skills and the capacity to
                                        efficiently utilize and contribute to your team s technical skills.</span>
                                    <br /><b class="dispnone careerreadmore">Read More →</b>
                                </label>
                                <div class="acc-body">
                                    <p class="mb-0"><b>Role: </b>Android Developer</p>
                                    <!-- <p class="mb-0 mt-0"><b>Job Location:</b> Mumbai
                                    <p class="mb-0 mt-0"><b>Experience:</b> 2 to 7 Yrs -->
                                    <!-- <p class="mb-0 mt-0"><b>Qualification:</b> B.E/ B. Tech/ M.E/ M.Tech/ MCA -->
                                    <p class="mb-0"><b>Job Description: </b>We are looking for highly motivated and
                                        quick learning individual with great leadership skills and the capacity to
                                        efficiently utilize and contribute to your team s technical skills. The ability
                                        to understand requirements, provide
                                        solutions, and collaborate efficiently and amicably with your team and with
                                        clients. The ability to work with the design
                                        team to implement mobile strategies. The focus to adapt and respond to
                                        challenges as they come up. Excellent time
                                        management skills and dedication to achieving high quality work.</p>
                                    <p class="mb-0 mt-0"><b>Responsibilities:</b></p>
                                    <ol>
                                        <li>Hands-on Application development knowledge on Kotlin language with MVVM /
                                            MVP architecture is must.</li>
                                        <li>The senior android engineer is expected to have published 5+ applications on
                                            play store.</li>
                                        <li>High level knowledge of Java I/O, Collections, Algorithms and other
                                            well-known application frameworks</li>
                                        <li>Experience with JSON to interfacing Android applications to server-side APIs
                                        </li>
                                        <li>Experience with source code management techniques using Git.</li>
                                        <li>Ability to develop rich GUIs for Android with latest material design and
                                            libraries.</li>
                                        <li>Constant awareness of the latest technological developments and a high level
                                            of expertise</li>
                                        <li>Having experience in Consumer App experience (B2C), designing and developing
                                            B2C Apps with interactive
                                            UI/UX, consumer engagement with Notifications and app analytics.</li>
                                    </ol>
                                    <p class="mb-0 mt-0"><b>Preferred:</b></p>
                                    <ol>
                                        <li>Published apps available for immediate download from Play Store</li>
                                        <li>Ability to develop APIs</li>
                                        <li>Experience developing user-facing applications</li>
                                        <li>Flexible, adaptable, and able to multi-task</li>
                                    </ol>
                                    
                                    <!-- <a href="javascript://" class="btn" data-toggle="modal"
                                        data-target="#applybtn">Apply Now</a> -->
                                       
                                </div>
                            </div>

                            <div class="col-md-6 col-xs-12 filterDiv show1 product engineering chennai mt-3">
                                <input type="checkbox" name="acc" id="acc8" class="career-input"
                                    onclick="getevent(this)">
                                <label for="acc8">iOS Developer <br /><br /><b>Location :
                                    </b><span>Chennai</span><br /><b>Experience : </b><span>4+
                                        Yrs</span><br /><b>Qualification : </b><span>B. E/ B. Tech/ M.E/ MTech/
                                        MCA</span>
                                    <br /><b>Description : </b><span>Should have hands-on experience in
                                        iOS applications and SDK development.Having experience with Swift programming
                                        language is a must.</span>
                                    <br /><b class="dispnone careerreadmore">Read More →</b>
                                </label>
                                <div class="acc-body">
                                    <p class="mb-0"><b>Role: </b>iOS Developer </p>
                                    <!-- <p class="mb-0 mt-0"><b>Job Location:</b> Mumbai
                                    <p class="mb-0 mt-0"><b>Experience:</b> 2 to 7 Yrs -->
                                    <!-- <p class="mb-0 mt-0"><b>Qualification:</b> B.E/ B. Tech/ M.E/ M.Tech/ MCA -->
                                    <p class="mb-0 mt-0"><b>Responsibilities:</b></p>
                                    <ol>
                                        <li>Should have hands-on experience in iOS applications and SDK development.
                                        </li>
                                        <li>Having experience with Swift programming language is a must.</li>
                                        <li>Prior experience in the basics of secure code development, like Jail Broken
                                            detection
                                            and advanced cryptographic algorithms, would be an added advantage.
                                        </li>
                                        <li>Working knowledge of Custom views, Animations, Services, and Database</li>
                                        <li>Solid understanding of the entire mobile development life cycle</li>
                                        <li>Should have published at least one original iOS app to the App store and
                                            supported it for one year.</li>
                                        <li>Expected to know Git repo management and release automation.</li>
                                        <li>Prior experience in the banking domain or Fraud and Risk management
                                            solutions
                                            would be an added advantage.</li>
                                        <li>Being a senior iOS engineer should be able to map the business requirement
                                            into
                                            an effective solution.</li>
                                        <li>Possess sufficient knowledge and skills to deal with issues effectively and
                                            challenges
                                            and troubleshoot any problems with a high sense of ownership.</li>
                                        <li>Should be able to devise solutions from a technology perspective and
                                            coordinate with
                                            the team in achieving a single common goal.</li>
                                        <li>
                                            Expected to guide the juniors and help them understand the conversion of
                                            business requirements into best-in-class solutions.
                                        </li>
                                    </ol>
                                    
                                    <!-- <a href="javascript://" class="btn" data-toggle="modal"
                                        data-target="#applybtn">Apply Now</a> -->
                                   
                                </div>
                            </div>

                            <div class="col-md-6 col-xs-12 filterDiv show1 product engineering chennai mt-3">
                                <input type="checkbox" name="acc" id="acc4" class="career-input"
                                    onclick="getevent(this)">
                                <label for="acc4">Mobile Application Security Researcher/Tester<br /><br /><b>Location :
                                    </b><span>Chennai</span><br /><b>Experience : </b><span>2 to 7
                                        Yrs</span><br /><b>Qualification : </b><span>B. E/ B. Tech/ M.E/ MTech/
                                        MCA</span><br /><b>Description : </b><span>Researching, evaluating, and helping
                                        developers to improve defensive tactics,
                                        techniques to secure the mobile application from threats and
                                        vulnerabilities.</span>
                                    <br /><b class="dispnone careerreadmore">Read More →</b>
                                </label>
                                <div class="acc-body">
                                    <p class="mb-0"><b>Role: </b>Mobile Application Security Researcher/Tester</p>
                                    <!-- <p class="mb-0 mt-0"><b>Job Location:</b> Mumbai
                                    <p class="mb-0 mt-0"><b>Experience:</b> 2 to 7 Yrs -->
                                    <!-- <p class="mb-0 mt-0"><b>Qualification:</b> B.E/ B. Tech/ M.E/ M.Tech/ MCA -->
                                    <p class="mb-0 mt-0"><b>Roles & Responsibilities:</b></p>
                                    <ol>
                                        <li>Researching, evaluating, and helping developers to improve defensive
                                            tactics, techniques to
                                            secure the mobile application from threats and vulnerabilities.</li>
                                        <li>Strong understanding of vulnerability assessment and triage</li>
                                        <li>2+ years of experience in Mobile Application Security and related security
                                            scanning and manual
                                            tools such as MobSF, Yaazini, APKTool, Frida, JADX, LSPosed / Xposed,
                                            Ghidra, Hopper, IDA Pro.
                                        </li>
                                        <li>2+years of experience in consultancy and support to application teams,
                                            including security
                                            scanning tool onboarding, vulnerability review and triage, false positive
                                            and rating challenges,
                                            scanning eligibility, and exceptions.</li>
                                        <li>Professional cybersecurity certificates on mobile application security are
                                            preferred.</li>
                                    </ol>
                                    <p class="mt-0 mb-0 "><b>Preferred:</b></p>
                                    <ol>
                                        <li>Mobile Application Security Assessment (Both Android and iOS)</li>
                                        <li>Security Scanning Tools - Onboarding, Vulnerability review, False positive
                                        </li>
                                        <!-- <li>A CEH certification will be an advantage.</li> -->
                                    </ol>
                                    
                                    <!-- <a href="javascript://" class="btn" data-toggle="modal"
                                        data-target="#applybtn">Apply Now</a> -->
                                   
                                </div>
                            </div>

                        </div>

                        <div class="row mb-3">
                            <div class="col-12 filterDiv show1 sales gurgaon mt-4">
                                <h3>Gurgaon</h3>
                            </div>
                            <div class="col-md-6 col-xs-12 filterDiv show1 sales gurgaon mt-3">
                                <input type="checkbox" name="acc" id="acc5" class="career-input"
                                    onclick="getevent(this)">
                                <label for="acc5">Customer Success Manager<br /><br /><b>Location :
                                    </b><span>Gurgaon</span><br /><b>Experience : </b><span>8+
                                        Yrs</span><br /><b>Description : </b><span>Channel Development Manager (CDM) OR
                                        Partner Success Manager (PSM) is responsible for developing and scaling
                                        Protectt.ai new channel partners to expand our footprint.</span>
                                    <br /><b class="dispnone careerreadmore">Read More →</b>
                                </label>
                                <div class="acc-body">
                                    <p class="mb-0"><b>Role:</b> Customer Success Manager</p>
                                    <p class="mb-0 mt-0"><b>Job Description:</b></p>

                                    <p>Channel Development Manager (CDM) OR Partner Success Manager (PSM) is responsible
                                        for
                                        developing and scaling Protectt.ai new channel partners to expand our footprint.
                                    </p>
                                    <p>This role will engage to develop new partners and help advance the partner to
                                        engage with their
                                        customers around Ptotectt.ai solutions. The CDM will be relentless in its
                                        pursuit to drive results.
                                    </p>
                                    <p>The CDM is a trusted advisor on Protectt.ai product and service offerings, has
                                        the industry
                                        knowledge, and knows how to leverage partnership relationships. The CDM will
                                        work across all
                                        disciplines at Protectt.ai, including Product, Customer Success, and Sales Ops,
                                        to help our partners
                                        provide our joint customers with Protectt.ai solutions.</p>
                                    <p>The CDM will be responsible for developing and executing a business plan to
                                        maximize revenues
                                        within partner accounts. This will include strategic planning and positioning of
                                        the product,
                                        facilitating product training to partners, working with Protectt.ai Labs
                                        marketing team to develop
                                        case studies, and industry-appropriate sales sheets, and coordinating customer
                                        events and programs
                                        to drive sales revenue through partners effectively.</p>
                                    <p>The CDM will also very closely track the status of each partner key contact and
                                        their stage in the
                                        partner process (i.e., needs support, sales readiness, engagement, etc.). They
                                        should be
                                        self-motivated to succeed at start-up speed. Able to articulate product and
                                        business strategies and
                                        have
                                        a proven track record of success in delivering results.</p>
                                    <p>The CDM will spend most of its time engaging with partners at multiple levels,
                                        managing
                                        relationships, and maximizing revenue.</p>

                                    <p class="mb-0 mt-0"><b>Responsibilities:</b></p>
                                    <ol>
                                        <li>Develop a Partner Business Plan and work closely with partners on business
                                            development and
                                            revenue targets.</li>
                                        <li>Manage partner pipelines and work with the partner sales team to cultivate
                                            new sales
                                            evangelizing the Protectt.ai value proposition</li>
                                        <li>Educate partners on Protectt.ai solutions and market focus, keeping them
                                            abreast of changes and
                                            new developments</li>
                                        <li>Train and enable partner sales and solution specialists in how to position
                                            and sell Protectt.ai
                                        </li>
                                        <li>Work closely with the Protectt.ai marketing team on developing marketing
                                            programs/campaigns to
                                            promote lead generation and awareness within the channel</li>
                                        <li>Demonstrate the capacity to think "outside the box" and motivate others to
                                            take well-reasoned
                                            risks</li>
                                        <li>Able to work independently with minimal supervision (and remotely)</li>
                                        <li>Ability to multi-task, prioritize, and manage time effectively</li>
                                        <li>Strong customer-facing and public presentation skills</li>
                                        <li>Strong organizational skills</li>
                                        <li>Excellent communication and interpersonal skills</li>
                                        <li>Strong listening and presentation skills</li>
                                        <li>Practical written and verbal skills</li>
                                        <li>Ability to thrive in a fast-paced, high-growth environment</li>
                                    </ol>
                                    <p class="mb-0 mt-0"><b>Desired Candidate Profile:</b></p>
                                    <ol>
                                        <li>8-10 years of total experience with min. 5-6years' experience in a channel
                                            sales role.</li>
                                        <li>Experience in Partner business ecosystem, planning, and keeping partner
                                            motivated on new ideas
                                            towards developing overall business growth and Preparing GTM based on the
                                            inputs from the
                                            Sales/Presales team.</li>
                                        <li>Excellent communication skills, both written and verbal.</li>
                                        <li>Ability to drive partner sales quota with the proper and approved plan.</li>
                                        <li>Ability to drive region quota with the support of selected partners.</li>
                                        <li>Ability to understand the client’s requirements with the support partner
                                            Team and take support
                                            from the internal sales and Presales Team.</li>
                                        <li>Building 2X Funnel of assigned Targets via partners.</li>
                                        <li>Good understanding of partner business cycle for BFSI vertical.</li>
                                        <li>Good understanding of BFSI, NBFC, PSU, Fintech, IT/ITES vertical.</li>
                                    </ol>
                                    
                                    <!-- <a href="javascript://" class="btn" data-toggle="modal"
                                        data-target="#applybtn">Apply Now</a> -->
                                   
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-12 mt-4" id="Null">
                                <h3>No Record Found...</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Service  -->
            <!-- Android Developer  -->
        </div>
    </div>

    <!-- Start Agency Benefits Area -->

    <div class="modal fade" id="applybtn" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content m-0 p-0 position-relative">
                <button type="button" class="btn position-top-right" data-dismiss="modal" aria-label="Close">
                    <span style="color: #000" aria-hidden="true">X</span>
                </button>
                <div class="modal-header">
                    <h4>Submit Your Application</h4>
                </div>
                <div class="modal-body">
                    <form [formGroup]="applyForm" class="contactusform">
                        <div class="row">

                            <!-- <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right"
                                    for="linkedinprofile">LinkedIN Profile</label>
                                <input type="text" id="linkedinprofile" class="form-control input"
                                    formControlName="linkedinprofile" name="linkedinprofile">
                                <h4><i class="fa fa-linkedin-square" aria-hidden="true"></i></h4>
                            </div> -->

                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right"
                                    for="resumeorcv">Resume/CV*</label>
                                <input type="file" id="resumeorcv" class="form-control validate input"
                                    formControlName="resumeorcv" name="resumeorcv" (change)="uploadFiletoS3Trigger($event)"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.resumeorcv.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.resumeorcv.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.resumeorcv.errors.required">* This field is required
                                    </div>
                                    <div *ngIf="getDemoForm.resumeorcv.errors.maxlength">* Please upload resume/cv
                                    </div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right" for="name">Full
                                    Name*</label>
                                <input type="text" placeholder="Enter Your Full Name" id="name"
                                    class="form-control validate input" formControlName="name" name="name"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                                    <div *ngIf="getDemoForm.name.errors.pattern">* Please enter valid name</div>
                                    <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter valid full name
                                    </div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right" for="email">Email*</label>
                                <input type="email" placeholder="Enter Your Email " formControlName="email"
                                    class="form-control input" id="email" name="email"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                                    <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                                    <div *ngIf="getDemoForm.email.errors.isValidEmail">* Plaese enter business email
                                    </div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right"
                                    for="contactnumber">Phone*</label>
                                <input type="text" placeholder="Enter Your Phone Number" id="contactnumber"
                                    class="form-control validate input" formControlName="contactnumber"
                                    name="contactnumber"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.contactnumber.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.contactnumber.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.contactnumber.errors.required">* This field is required
                                    </div>
                                    <div *ngIf="getDemoForm.contactnumber.errors.pattern">* Please, Enter 10 digit
                                        Mobile
                                        Number.
                                    </div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right" for="company_name">Current
                                    Company*</label>
                                <input type="text" placeholder="Enter Your Company Name" id="company_name"
                                    class="form-control validate input" formControlName="company_name"
                                    name="company_name"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company_name.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.company_name.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.company_name.errors.required">* This field is required
                                    </div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right" for="currentctc">Current
                                    CTC*</label>
                                <input type="text" placeholder="Enter Your Current CTC" id="currentctc"
                                    class="form-control validate input" formControlName="currentctc" name="currentctc"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.currentctc.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.currentctc.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.currentctc.errors.required">* This field is required
                                    </div>
                                </div>
                            </div>

                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right" for="noticeperiod">Notice
                                    Period*</label>
                                <input type="text" id="noticeperiod" class="form-control validate input"
                                    formControlName="noticeperiod" name="noticeperiod"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.noticeperiod.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.noticeperiod.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.noticeperiod.errors.required">* This field is required
                                    </div>
                                </div>
                            </div>
                            <div class="md-form mb-20 col-md-4">
                                <label class="mb-0" data-error="wrong" data-success="right"
                                    for="currentlocation">Current
                                    Location*</label>
                                <input type="text" id="currentlocation" class="form-control validate input"
                                    formControlName="currentlocation" name="currentlocation"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.currentlocation.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.currentlocation.errors"
                                    class="invalid-feedback">
                                    <div *ngIf="getDemoForm.currentlocation.errors.required">* This field is
                                        required</div>
                                </div>
                            </div>
                        </div>

                        <div class="md-form">
                            <label class="mb-0" data-error="wrong" data-success="right" for="message">Additional
                                Information</label>
                            <textarea maxlength="250" placeholder="Must be under 250 characters." type="text"
                                id="message" class="md-textarea form-control" formControlName="message" name="message"
                                rows="2">
                          </textarea>
                        </div>
                        <div class="modal-footer d-flex justify-content-center">
                            <button class="btn btn-unique" id="closeModal" (click)="submitDemoForm()">Send</button>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="playEmplyoeeVideo" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-md w-98vh" role="document">
            <div class="modal-content m-0 p-0 h-98vh position-relative" *ngIf="videoUrl != ''">
                <button type="button" class="btn position-top-right" data-dismiss="modal" aria-label="Close">
                    <span style="color: #fff" aria-hidden="true">X</span>
                </button>
                <iframe id="videospeak" [src]='getMainContentTrusted(videoUrl)' width="100%" height="100%"
                    frameborder="0" allowtransparency="true" webkitallowfullscreen mozallowfullscreen
                    allowfullscreen allow="autoplay">
                </iframe>
            </div>
        </div>
    </div>
    <!-- End Agency Benefits Area -->